export default __webpack_public_path__ + "static/imda2019meritaward-d21c2c39902f55a0f411d725e33ad6d4.jpg";